module.exports = __webpack_public_path__ + "static/media/amex.e95bef8e.svg";